import type { SearchProps } from './result-base';
import SearchResultBase from './result-base';
import { emphasizeAndEscapeText } from './emphasize-text';

export type { SearchProps };
export { SearchResultBase, emphasizeAndEscapeText };
